import { SetRoutes } from 'components';
import routes from './routes';

const UsersRolesPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default UsersRolesPage;
